import type { GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import ServicesForPartnerPage from '../../components/ServicesForPartner';
import fetchUtil from '../../utils/fetchUtil';


const StudyAbraodAssociation: NextPage = (props: any) => {
  const { meta } = props?.pageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#226CF5');
    customStyle.setProperty('--navbar-menu-color', '#ffff')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <ServicesForPartnerPage {...props} />
    </>
  )
}


export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/services-partners`, 'GET', {}, '', false)
  return {
    props: { pageData }
  };
}

export default StudyAbraodAssociation;